import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {getEdge365ChallengeTasks} from '/redux/action/coach.action';
import {
  coachTasks,
  hasEdge365ChallengeTasksById,
  highestAchievedRankDescriptionById,
  latestStreak,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {fromProps, withProps} from '/util/selector.util';

import Edge365MainScreen from './Edge365MainScreen';

const withCoachId = withProps({
  coachId: fromProps(get('coachId')),
});

export default connect(
  createStructuredSelector({
    coachId: userId,
    hasEdge365ChallengeTasks: withCoachId(hasEdge365ChallengeTasksById),
    edge365ChallengeTasks: withCoachId(coachTasks),
    latestStreakData: withCoachId(latestStreak),
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestRankDescription: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
  }),
  dispatch => ({
    getEdge365ChallengeTasks: ({
      coachId,
      month,
      year,
    }: {
      coachId: any;
      month: number;
      year: number;
    }) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getEdge365ChallengeTasks({coachId, month, year})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      getEdge365ChallengeTasks: ({
        coachId,
        month,
        year,
      }: {
        month: number;
        year: number;
        coachId: string;
      }) => {
        return dispatchProps.getEdge365ChallengeTasks({
          coachId,
          month,
          year,
        });
      },
    };
  },
)(Edge365MainScreen);
